/** True when the app runs inside an Electron webview (e.g. Cursor / VS Code Simple Browser). */
export function isEmbeddedAppBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return /Electron/i.test(ua) || /\bCursor\b/i.test(ua);
}

/**
 * Embedded browsers expose Web Speech constructors but sessions end immediately
 * (network / service-not-allowed). Route those clients to server-side live ASR.
 */
export function prefersServerVoiceInput(): boolean {
  return isEmbeddedAppBrowser();
}
